<div class="h-100 w-100">
  <app-header [title]="'DEXIO'" ></app-header>
  <app-sidebar></app-sidebar>
  <!-- <app-right-sidebar></app-right-sidebar> -->
  <div [dir]="direction">
    <router-outlet></router-outlet>
  </div>
</div>

